import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { Col, Row } from "react-bootstrap";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { FixedAssetsTakeInAccountDto } from "../../../../dtos/documents/FixedAssetsTakeInAccounts/FixedAssetsTakeInAccountDto";
import { FixedAssetsTakeInAccountsModel } from "../../../../models/Documents/FixedAssetsTakeInAccounts/FixedAssetsTakeInAccountsModel";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import FixedAssetsTakeInAccountsDetailsSkeleton from "./FixedAssetsTakeInAccountsDetailsSkeleton";
import { FixedAssetsTakeInAccountsDetailMain } from "./FixedAssetsTakeInAccountsDetailMain";
import { FixedAssetsTakeInAccountsDetailAccountConstruction } from "./FixedAssetsTakeInAccountsDetailAccountConstruction";
import { useTranslation } from "react-i18next";
import { FixedAssetsTakeInAccountsDetailFooter } from "./FixedAssetsTakeInAccountsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";
interface IProps {
  model: FixedAssetsTakeInAccountDto | null;
  modelUpdatedEvent: (newModel: FixedAssetsTakeInAccountDto) => void;
}

const FixedAssetsTakeInAccountsDetails = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<FixedAssetsTakeInAccountsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Take In Account");
  const [selectedOpType, setSelectedOpType] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    console.log(model);

    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("fixedAssetId", model.fixedAssetId);
      setValue("warehouseId", model.warehouseId);
      setValue("companyId", model.companyId);
      setValue("takeInAccountDate", model.takeInAccountDate);
      setValue("lifeDuration", model.lifeDuration);
      setValue("depreciationMethod", model.depreciationMethod);
      setValue("fixedAssetsTakeInAccountConstructionObjectDto", model.fixedAssetsTakeInAccountConstructionObjectDto);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: FixedAssetsTakeInAccountsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <FixedAssetsTakeInAccountsDetailsSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.FixedAssetsTakeInAccounts.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Construction Objects"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <FixedAssetsTakeInAccountsDetailMain />
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <FixedAssetsTakeInAccountsDetailAccountConstruction />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={t("Comment")} required={false} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <FixedAssetsTakeInAccountsDetailFooter />
    </FormProvider>
  );
};

export default FixedAssetsTakeInAccountsDetails;
